import type { People } from '@/hooks/usePeople'
import './Avatar.css'

interface AvatarProps {
  uid: string
  people: People
  label?: string
  small?: boolean
}

/** A person's letter in their colour, on a soft tint of it. Never a task's ring, so it never reads as a category. */
export function Avatar({ uid, people, label, small = false }: AvatarProps) {
  return (
    <span className={`avatar avatar--${people.toneOf(uid)} ${small ? 'avatar--small' : ''}`} role="img" aria-label={label ?? people.names[uid] ?? 'Someone'}>
      {people.initials[uid] ?? '?'}
    </span>
  )
}

/** Both people overlapping: "either of us". */
export function PairAvatars({ people, small = false }: { people: People; small?: boolean }) {
  const [a, b] = people.pair
  if (!b) return a ? <Avatar uid={a} people={people} label="Either of us" small={small} /> : null
  return (
    <span className="avatar-pair" role="img" aria-label="Either of us">
      <span className={`avatar avatar--${people.toneOf(a)} avatar--stacked ${small ? 'avatar--small' : ''}`}>{people.initials[a]}</span>
      <span className={`avatar avatar--${people.toneOf(b)} avatar--stacked avatar--overlap ${small ? 'avatar--small' : ''}`}>{people.initials[b]}</span>
    </span>
  )
}
